import { Component, inject, ChangeDetectionStrategy, DestroyRef } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { LayoutStoreService } from '@core/services/layout-store.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IntegrationProfileStateService } from '@core/services/integration-profile-state.service';
import { IntegrationProfilesService } from '@core/api/api/integrationProfiles.service';
import { IntegrationProfileSelectorComponent } from '@shared/components/integration-profile-selector/integration-profile-selector.component';
import { AuthService } from '@core/services/auth.service';
import { CurrentUserService } from '@core/services/current-user.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-topbar',
  imports: [
    NgIcon,
    NgbDropdownModule,
    IntegrationProfileSelectorComponent,
    TranslocoPipe,
    RouterLink,
  ],
  templateUrl: './topbar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent implements OnInit {
  readonly layout = inject(LayoutStoreService);
  readonly profileState = inject(IntegrationProfileStateService);
  readonly currentUserService = inject(CurrentUserService);

  private readonly integrationProfilesService = inject(IntegrationProfilesService);
  private readonly authService = inject(AuthService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.loadProfiles();
  }

  toggleSidebar(): void {
    const html = document.documentElement;
    const currentSize = html.getAttribute('data-sidenav-size');

    if (currentSize === 'offcanvas') {
      html.classList.toggle('sidebar-enable');
      this.layout.showBackdrop();
    } else {
      this.layout.setSidenavSize(currentSize === 'collapse' ? 'default' : 'collapse');
    }
  }

  onProfileChange(profileId: string | null): void {
    this.profileState.setSelectedProfile(profileId);
  }

  logout(): void {
    this.authService.logout();
  }

  private loadProfiles(): void {
    this.profileState.setProfilesLoading(true);
    this.integrationProfilesService
      .listIntegrationProfiles()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (profiles) => {
          this.profileState.setProfiles(profiles);
          this.profileState.setProfilesLoading(false);
        },
        error: () => {
          this.profileState.setProfilesLoading(false);
        },
      });
  }
}
